import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor() {
    this.setupNetworkListeners();
  }

  private setupNetworkListeners(): void {
    // Browser events
    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).subscribe(isOnline => this.online$.next(isOnline));

    // Capacitor Network API
    Network.addListener('networkStatusChange', status => {
      this.online$.next(status.connected);
    });

    // Initial check using Capacitor
    Network.getStatus().then(status => {
      this.online$.next(status.connected);
    });
  }

  public isOnline(): Observable<boolean> {
    return this.online$.asObservable().pipe(
      distinctUntilChanged(),
      shareReplay(1)
    );
  }

  public async getCurrentNetworkStatus(): Promise<boolean> {
    const status = await Network.getStatus();
    return status.connected;
  }
}